// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.collapse1 .ant-collapse {
  border: none;
}
.collapse1 .ant-collapse-item-active {
  border: none !important;
}
.collapse1 .ant-collapse > .ant-collapse-item > .ant-collapse-header {
  font-weight: 600;
  font-size: 18px;
  line-height: 16px !important;
  color: #004195 !important;
}
.collapse1 .ant-collapse-header-text {
  align-self: center;
}
.collapse1 .ant-collapse-header {
  height: 60px !important;
  background: #f4f8fc !important;
  border: none !important;
}
.collapse1 .ant-collapse > .ant-collapse-item {
  border-bottom: 2px solid white !important;
}
.collapse1 .ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow {
  border: none !important;
  font-weight: 800;
  border-radius: 5px;
  background-color: #ffffff;
  padding: 5px;
  border: 1px solid #004195;
  color: #004195;
}

.ant-collapse-content {
  border: none !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Accordian/Accordian.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,UAAA;EACA,sBAAA;AACF;;AAGE;EACE,YAAA;AAAJ;AAGE;EACE,uBAAA;AADJ;AAIE;EACE,gBAAA;EACA,eAAA;EACA,4BAAA;EACA,yBAAA;AAFJ;AAKE;EACE,kBAAA;AAHJ;AAME;EACE,uBAAA;EACA,8BAAA;EACA,uBAAA;AAJJ;AAOE;EACE,yCAAA;AALJ;AAQE;EACE,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;AANJ;;AAUA;EACE,uBAAA;AAPF","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.collapse1 {\n  .ant-collapse {\n    border: none;\n  }\n\n  .ant-collapse-item-active {\n    border: none !important;\n  }\n\n  .ant-collapse > .ant-collapse-item > .ant-collapse-header {\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 16px !important;\n    color: #004195 !important;\n  }\n\n  .ant-collapse-header-text {\n    align-self: center;\n  }\n\n  .ant-collapse-header {\n    height: 60px !important;\n    background: #f4f8fc !important;\n    border: none !important;\n  }\n\n  .ant-collapse > .ant-collapse-item {\n    border-bottom: 2px solid white !important;\n  }\n\n  .ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow {\n    border: none !important;\n    font-weight: 800;\n    border-radius: 5px;\n    background-color: #ffffff;\n    padding: 5px;\n    border: 1px solid #004195;\n    color: #004195;\n  }\n}\n\n.ant-collapse-content {\n  border: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
